const DEFAULT_CURRENCY = {
  CURRENCY_NAME: 'trophy',
  CURRENCY_NAME_PLURAL: 'trophies',
};

export default DEFAULT_CURRENCY;
